document.addEventListener("DOMContentLoaded", function () {
  let walker = document.createTreeWalker(
    document.body,
    NodeFilter.SHOW_TEXT,
    null,
    false
  );

  let node;
  while ((node = walker.nextNode())) {
    if (
      (node.nodeValue && node.nodeValue.indexOf("ß") !== -1) ||
      node.nodeValue.indexOf("ẞ") !== -1
    ) {
      node.nodeValue = node.nodeValue.replace(/ß/g, "ss").replace(/ẞ/g, "SS");
    }
  }
});
